// extracted by mini-css-extract-plugin
export default {"wrapper":"GetName_wrapper__3nisf","active":"GetName_active__bsIKG"};